module.exports = __webpack_public_path__ + "helveticaneue_thin-webfont.3279b5892d1e802dae96.ttf";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/assets/fonts/helveticaneue_thin-webfont.ttf
// module id = ../../../../../src/assets/fonts/helveticaneue_thin-webfont.ttf
// module chunks = styles